(function () {
	// save the section id from the script tag and find the section
	const sectionID = document.currentScript.dataset.id;
	const section = document.querySelector(`#${sectionID}`);

	// exit if section is not found
	if (!section) {
		console.warn(`Product section with ID ${sectionID} not found.`);
		return;
	}

	// get the key values from the section
	function getCheckedSizeInput() {
		let selected = section.querySelector(".productSizeLabelInput:checked");
		if (!selected) {
			const sizeInputs = Array.from(section.querySelectorAll(".productSizeLabelInput"));
			if (sizeInputs.length > 0) {
				sizeInputs.sort((a, b) => parseInt(b.value || "0") - parseInt(a.value || "0"));
				selected = sizeInputs[0];
				selected.checked = true;
			}
		}
		return selected;
	}

	// keep track of the last product cap & the max product cap
	let lastProductCap = parseInt(getCheckedSizeInput()?.value || "1");
	let maxProductCap = 0;
	section.querySelectorAll(".productSizeLabelInput").forEach(function (element) {
		let productCap = parseInt(element.value);
		if (productCap > maxProductCap) {
			maxProductCap = productCap;
		}
	});

	let productsToAddCount = 0;
	let productsToAdd = [];


	// during dev mode, set the active variant to the window so it can be accessed in the console
	if (Shopify.theme.role === "development") {
		window.productsToAdd = productsToAdd;
	}

	// save a reference product to use for initialization (pricing)
	const isMixNMatchMaltertechTemplate = section.dataset.template === "product.mix-n-match-maltertech";
	// check the picker, not the cards: sold-out cards aren't rendered, and an
	// all-sold-out page must not fall into the single-SKU flow below.
	const hasFlavorPicker = !!section.querySelector(".productFlavors");
	let mainProductVariant = null;
	let mainProductSubscriptionPlanId = null;

	// mix-n-match and the single-SKU buy box both add the main product itself
	const productVariantJSON = section.querySelector(".productVariantJSON");
	if (productVariantJSON) {
		try {
			mainProductVariant = JSON.parse(productVariantJSON.textContent);
			if (Array.isArray(mainProductVariant?.selling_plan_allocations) && mainProductVariant.selling_plan_allocations.length > 0) {
				const firstAllocation = mainProductVariant.selling_plan_allocations[0];
				mainProductSubscriptionPlanId = firstAllocation?.selling_plan_id || null;
			}
		} catch (error) {
			console.warn("Unable to parse product variant JSON for main product.", error);
		}
	}

	// reference price: first flavor card, or the main product if there are none
	let referencePrice = section.querySelector(".productFlavorsBodyItem")?.dataset.price || mainProductVariant?.price;

	const isV2Layout = section.dataset.layout === "v2";
	const servingsPerBag = parseInt(section.dataset.servings) || 0;
	const oneTimePricePerServingOverride = parseFloat(section.dataset.oneTimePricePerServing || "0") || 0;
	const flavorsMinOverride = parseInt(section.dataset.flavorsMin || "0") || 0;
	const flavorsMaxOverride = parseInt(section.dataset.flavorsMax || "0") || 0;
	const bundleConfigEl = section.querySelector(".productBundleConfig");
	const bundleAddOnEls = section.querySelectorAll(".productBundleAddOnItem");
	const bundleGiftEls = section.querySelectorAll(".productBundleGiftItem");

	function getFlavorSelectionLimits(productCap) {
		let minRequired = flavorsMinOverride > 0 ? flavorsMinOverride : productCap;
		let maxAllowed = flavorsMaxOverride > 0 ? flavorsMaxOverride : Number.POSITIVE_INFINITY;
		if (maxAllowed < minRequired) maxAllowed = minRequired;
		return { minRequired, maxAllowed };
	}

	/************
		 Product slider (Embla)
	 ************/

	async function initializeEmbla() {
		// wait for Embla to be available
		const waitForEmbla = () =>
			new Promise((resolve) => {
				if (typeof EmblaCarousel !== "undefined" && typeof EmblaCarouselAutoHeight !== "undefined") return resolve();
				const id = setInterval(() => {
					if (typeof EmblaCarousel !== "undefined" && typeof EmblaCarouselAutoHeight !== "undefined") {
						clearInterval(id);
						resolve();
					}
				}, 50);
			});

		await waitForEmbla();

		const viewport = section.querySelector(".productVisualSwiperViewport");
		const mainNode = section.querySelector(".productVisualSwiper");
		const thumbsNode = section.querySelector(".productVisualGalleryViewport");
		const prevBtn = section.querySelector(".productVisualSwiperPrev");
		const nextBtn = section.querySelector(".productVisualSwiperNext");

		if (!viewport || !thumbsNode) return;

		const thumbsApi = EmblaCarousel(thumbsNode, {
			align: "start",
			containScroll: "keepSnaps",
			dragFree: false,
			loop: false,
			slidesToScroll: 1
		});

		const mainApi = EmblaCarousel(viewport, {
			align: "center",
			loop: true,
			containScroll: false
		}, [EmblaCarouselAutoHeight()]);

		const syncThumbs = () => {
			const index = mainApi.selectedScrollSnap();
			const thumbSlides = thumbsApi.slideNodes();
			if (thumbSlides.length <= 1) {
				thumbSlides.forEach((slide) => {
					slide.classList.toggle("is-selected", parseInt(slide.dataset.slideIndex) === index);
					slide.classList.remove("is-hidden");
				});
				return;
			}

			// Toggle selection and hide the active slide's thumbnail (if it exists).
			thumbSlides.forEach((slide) => {
				const slideIndex = parseInt(slide.dataset.slideIndex);
				const isActive = slideIndex === index;
				slide.classList.toggle("is-selected", isActive);
				slide.classList.toggle("is-hidden", isActive);
			});

			const findThumbIndex = (predicate) => {
				for (let i = 0; i < thumbSlides.length; i++) {
					if (predicate(thumbSlides[i])) return i;
				}
				return -1;
			};

			// Scroll to the next available (non-hidden) thumbnail.
			const nextIdx = findThumbIndex((slide) => {
				const slideIndex = parseInt(slide.dataset.slideIndex);
				return slideIndex > index && !slide.classList.contains("is-hidden");
			});
			const fallbackIdx = findThumbIndex((slide) => !slide.classList.contains("is-hidden"));
			const targetThumbIdx = nextIdx !== -1 ? nextIdx : Math.max(fallbackIdx, 0);

			thumbsApi.scrollTo(targetThumbIdx);
		};

		thumbsApi.slideNodes().forEach((thumb) => {
			thumb.addEventListener("click", () => {
				const slideIndex = parseInt(thumb.dataset.slideIndex);
				mainApi.scrollTo(slideIndex);
			});
		});

		const handleVideos = () => {
			const idx = mainApi.selectedScrollSnap();
			mainApi.slideNodes().forEach((slide, i) => {
				const video = slide.querySelector("video");
				if (!video) return;
				if (i === idx) {
					video.play().catch(() => { });
				} else {
					video.pause();
				}
			});
		};

		mainApi.on("select", () => {
			syncThumbs();
			handleVideos();
		});

		mainApi.on("init", () => { // needed to prevent layoutshift (AutoHeight plugin loads after some time from init)
			setTimeout(() => mainNode.classList.add("is-initialized"), 450);
		});

		mainApi.on("reInit", () => {
			syncThumbs();
			handleVideos();
		});



		prevBtn?.addEventListener("click", () => mainApi.scrollPrev());
		nextBtn?.addEventListener("click", () => mainApi.scrollNext());


		syncThumbs();
		handleVideos();
	}

	initializeEmbla();


	// set up dropdowns
	section.querySelectorAll(".productNutritionTop").forEach(element => {
		element.addEventListener("click", function () {
			this.classList.toggle("active");
			if (this.classList.contains("active")) {
				const checked = section.querySelector(".productNutritionMenuBottomWrapContentLabelInput:checked");
				if (checked) {
					const target = checked.value;
					const img = section.querySelector(`.productNutritionBottomWrapContentImg[data-target="${target}"]`);
					if (img) {
						img.classList.add("active");
					}
				}
			}
		});
	});

	section.querySelectorAll(".productNutritionMenuTop").forEach(element => {
		element.addEventListener("click", function () {
			this.classList.toggle("active");
		});
	});

	// nutritional info radio switch
	section.querySelectorAll(".productNutritionMenuBottomWrapContentLabelInput").forEach(input => {
		input.addEventListener("change", function () {
			let target = this.value;

			// show/hide the nutritional images
			section.querySelectorAll(".productNutritionBottomWrapContentImg").forEach(element => {
				if (element.dataset.target === target) {
					element.classList.add("active");
				} else {
					element.classList.remove("active");
				}
			});

			// update title
			section.querySelectorAll(".productNutritionMenuTopFlavor").forEach(element => {
				element.textContent = this.dataset.flavor;
			});

		});
	});


	// update active variant on input changes
	section.querySelectorAll("input, select").forEach(function (element) {
		element.addEventListener("change", function () {
			updateProduct();
		});
	});

	/**************
		 Update Product
	 ***************/

	function isSubscription() {
		return !!section.querySelector(`.productSellingLabelInput[value="sub"]:checked`);
	}

	// init prices
	let basePrice = referencePrice;

	async function updateProduct() {
		// get the current bundle size - this caps how many products they can add
		let productCap = parseInt(getCheckedSizeInput()?.value || "1");
		productsToAdd = [];

		// update each product
		section.querySelectorAll(".productFlavorsBodyItem").forEach(function (element) {
			let quantity = parseInt(element.dataset.quantity);

			// if quantity is greater than 0, show the + - UI and add the product
			if (quantity > 0) {
				element.querySelector(".productFlavorsBodyItemContentControlsWrap").classList.add("active");

				let selling_plan = null;
				if (isSubscription()) {
					selling_plan = parseInt(element.dataset.plan);
				}
				productsToAdd.push({
					id: element.dataset.id,
					title: element.dataset.title || "",
					quantity: quantity,
					price: element.dataset.price,
					selling_plan: selling_plan,
				});
			} else {
				element.querySelector(".productFlavorsBodyItemContentControlsWrap").classList.remove("active");
			}
		});
		productsToAddCount = productsToAdd.reduce((acc, item) => acc + item.quantity, 0);

		// single-SKU buy box (no flavor cards): the size/bag tier selected IS
		// the quantity of the main product, no per-flavor summing to do.
		if (!hasFlavorPicker && !isMixNMatchMaltertechTemplate && mainProductVariant?.id) {
			productsToAdd = [{
				id: mainProductVariant.id,
				title: mainProductVariant.title || "",
				quantity: productCap,
				price: mainProductVariant.price,
				selling_plan: isSubscription() ? mainProductSubscriptionPlanId : null,
			}];
			productsToAddCount = productCap;
		}

		/**************
				 Gifts
		 ***************/
		const giftsTitle = section.querySelector(".productGiftsTitle");
		const giftItems = section.querySelectorAll(".productGiftsBodyItem");
		if (giftsTitle) {
			if (isSubscription()) {
				giftsTitle.textContent = "YOUR FREE GIFTS!";
				giftsTitle.classList.add("active");
				giftItems.forEach(function (element) {
					element.classList.add("active");
				});
			} else {
				giftsTitle.textContent = "FREE GIFTS WITH SUBSCRIPTION";
				giftsTitle.classList.remove("active");
				giftItems.forEach(function (element) {
					element.classList.remove("active");
				});
			}
		}


		/**************
				 Perks
		 ***************/
		if (!isMixNMatchMaltertechTemplate) {
			section.querySelectorAll(".productPerkItem").forEach(function (element) {
				let subRequired = JSON.parse(element.dataset.needsSub);
				let unlockedAt = JSON.parse(element.dataset.unlockedAt);

				// check if this perk is unlocked
				let unlocked = false;
				if (subRequired && isSubscription() && productCap >= unlockedAt) {
					unlocked = true;
				} else if (!subRequired && productCap >= unlockedAt) {
					unlocked = true;
				}

				// toggle
				if (unlocked) {
					element.classList.add("active");
				} else {
					element.classList.remove("active");
				}
			});
		}


		if (isV2Layout && !isMixNMatchMaltertechTemplate) {
			/**************
					 SYNC SIZE (Progress Bar)
			 ***************/
			let tiers = Array.from(section.querySelectorAll(".productSizeLabelInput"));
			tiers.sort((a, b) => parseInt(a.value) - parseInt(b.value));

			let countToMatch = Math.max(1, productsToAddCount);

			let targetTier = tiers.find(t => parseInt(t.value) === countToMatch);
			if (!targetTier) {
				targetTier = tiers.find(t => parseInt(t.value) >= countToMatch);
			}

			if (targetTier && parseInt(targetTier.value) !== productCap) {
				targetTier.checked = true;
				productCap = parseInt(targetTier.value);
			} else if (!targetTier && tiers.length > 0) {
				let maxTier = tiers[tiers.length - 1];
				if (maxTier && parseInt(maxTier.value) !== productCap) {
					maxTier.checked = true;
					productCap = parseInt(maxTier.value);
				}
			}

			const activeStep = section.querySelector(`.bundle-step[data-value="${productCap}"]`);
			const lineContainer = section.querySelector(".bundle-progress-line");
			const fill = section.querySelector(".bundle-progress-fill");
			if (activeStep && lineContainer && fill) {
				if (productsToAddCount === 0) {
					fill.style.width = "0%";
				} else {
					const stepCircle = activeStep.querySelector(".bundle-step-circle");
					if (stepCircle) {
						const stepRect = stepCircle.getBoundingClientRect();
						const containerRect = lineContainer.getBoundingClientRect();
						const offset = stepRect.left + stepRect.width / 2 - containerRect.left;
						const percent = Math.min(100, Math.max(0, (offset / containerRect.width) * 100));
						fill.style.width = `${percent}%`;
					}
				}
			}

			section.querySelectorAll(".bundle-step").forEach(step => {
				const stepVal = parseInt(step.dataset.value);
				if (stepVal <= productsToAddCount) {
					step.classList.add("active");
				} else {
					step.classList.remove("active");
				}
			});
		} else {
			/**************
					 UPGRADE
			 ***************/
			// If the products to add count is greater than the current product cap,
			// and we didn't just downgrade,
			// and the product cap is less than the max product cap, upgrade the cap
			if (productsToAddCount > productCap && productCap < maxProductCap && lastProductCap <= productCap) {
				// find the next tier and select it
				let tiers = section.querySelectorAll(".productSizeLabelInput");
				tiers = Array.from(tiers).sort((a, b) => parseInt(a.value) - parseInt(b.value));
				for (let tier of tiers) {
					if (parseInt(tier.value) > productCap) {
						tier.checked = true;
						break;
					}
				}
				productCap = parseInt(getCheckedSizeInput()?.value || "1");
			}

			/**************
					 DOWNGRADE
			 ***************/
			// if they clicked a tier lower than our products added,
			// and the product cap is less than the last product cap,
			// remove all and reset the quantities
			if (productsToAddCount > productCap && productCap < lastProductCap) {
				section.querySelectorAll(".productFlavorsBodyItem").forEach(function (element) {
					element.dataset.quantity = 0;
					element.querySelector(".productFlavorsBodyItemContentControlsWrap").classList.remove("active");
					element.querySelector(".productFlavorsBodyItemContentControlsCount").textContent = 0;
				});
				productsToAddCount = 0;
				productsToAdd = [];
			}
		}

		// Recomputed here (not at the top of updateProduct) because the sync/
		// upgrade logic above can reassign `productCap` — using the value
		// from before that would leave the ATC "select N more flavor" check
		// requiring the OLD tier's flavor count even after the size selector
		// has already auto-adjusted to match what's actually selected.
		// single-SKU: no flavors to pick, so ATC is never gated on "N more".
		const minRequired = hasFlavorPicker ? getFlavorSelectionLimits(productCap).minRequired : 0;

		/**************
				 PRICES
		 ***************/
		let totalPrice = 0;
		let totalCompare = "";

		// Past the highest tier the size selector stops climbing, so pricing has to
		// follow the real bag count instead of the tier: every bag gets the top
		// tier's rate.
		const discountedQuantity = Math.max(productCap, productsToAddCount);

		if (isV2Layout) {
			// update size prices in progress bar
			section.querySelectorAll(".bundle-step").forEach(function (element) {
				let input = element.querySelector(".productSizeLabelInput");
				let subDiscount = parseFloat(input.dataset.discountSub);
				let onceDiscount = parseFloat(input.dataset.discountOnce);
				let discountedPrice = basePrice * (1 - onceDiscount / 100);
				let currentDiscount = onceDiscount;
				if (isSubscription()) {
					discountedPrice = basePrice * (1 - subDiscount / 100);
					currentDiscount = subDiscount;
				}
				const priceEl = element.querySelector(".bundle-step-price");
				if (priceEl) priceEl.textContent = `${price(discountedPrice, true)}/each`;

				const discountEl = element.querySelector(".bundle-step-discount");
				if (discountEl) {
					if (currentDiscount > 0) {
						discountEl.textContent = `Save ${currentDiscount.toFixed(0)}%`;
						discountEl.style.display = "block";
					} else {
						discountEl.style.display = "none";
					}
				}
			});
		} else {
			// update size prices
			section.querySelectorAll(".productSizeLabel").forEach(function (element) {
				let input = element.querySelector(".productSizeLabelInput");
				let subDiscount = parseFloat(input.dataset.discountSub);
				let onceDiscount = parseFloat(input.dataset.discountOnce);
				let discountedPrice = basePrice * (1 - onceDiscount / 100);
				if (isSubscription()) {
					discountedPrice = basePrice * (1 - subDiscount / 100);
				}
				element.querySelector(".productSizeLabelBodyPrice").textContent = `${price(discountedPrice, true)}/each`;

				// boxed size picker only: green "Save X%" line, same copy as the progress bar
				const saveEl = element.querySelector(".productSizeLabelBodySave");
				if (saveEl) {
					const currentDiscount = isSubscription() ? subDiscount : onceDiscount;
					saveEl.textContent = currentDiscount > 0 ? `Save ${currentDiscount.toFixed(0)}%` : "";
				}
			});

			// lets CSS swap plan-dependent badges (e.g. the FREE SHIPPING badge)
			section.dataset.plan = isSubscription() ? "sub" : "once";
		}

		// update sub input prices
		const selectedSizeInput = getCheckedSizeInput();
		let subDiscount = parseFloat(selectedSizeInput?.dataset.discountSub || "0");
		let onceDiscount = parseFloat(selectedSizeInput?.dataset.discountOnce || "0");

		section.querySelector(".productSellingLabelBodyBadge").textContent = ``;
		if (subDiscount > 0) {
			section.querySelector(".productSellingLabelBodyBadge").textContent = `Save ${subDiscount.toFixed(0)}% on first order`;
		}

		let discountedPrice = basePrice * (1 - onceDiscount / 100) * discountedQuantity;
		let subDiscountedPrice = basePrice * (1 - subDiscount / 100) * discountedQuantity;

		section.querySelector(".productSellingLabelBodyPriceReal.sub").textContent = `${price(subDiscountedPrice, true)}`;
		section.querySelector(".productSellingLabelBodyPriceReal.once").textContent = `${price(discountedPrice, true)}`;

		// compare price
		section.querySelector(".productSellingLabelBodyPriceCompare.once").textContent = ``;
		if (isV2Layout) {
			section.querySelector(".productSellingLabelBodyPriceReal.sub").classList.add("bold");
			section.querySelector(".productSellingLabelBodyPriceReal.once").classList.add("bold");
		} else {
			section.querySelector(".productSellingLabelBodyPriceReal.sub").classList.remove("bold");
			section.querySelector(".productSellingLabelBodyPriceReal.once").classList.remove("bold");
		}
		if (onceDiscount > 0 && (!isV2Layout || basePrice * discountedQuantity > discountedPrice)) {
			if (!isV2Layout) {
				section.querySelector(".productSellingLabelBodyPriceReal.once").classList.add("bold");
			}
			section.querySelector(".productSellingLabelBodyPriceCompare.once").textContent = `${price(basePrice * discountedQuantity, true)}`;
		}

		section.querySelector(".productSellingLabelBodyPriceCompare.sub").textContent = ``;
		if (subDiscount > 0 && (!isV2Layout || basePrice * discountedQuantity > subDiscountedPrice)) {
			if (!isV2Layout) {
				section.querySelector(".productSellingLabelBodyPriceReal.sub").classList.add("bold");
			}
			section.querySelector(".productSellingLabelBodyPriceCompare.sub").textContent = `${price(basePrice * discountedQuantity, true)}`;
		}

		if (oneTimePricePerServingOverride > 0) {
			const oncePerServing = oneTimePricePerServingOverride * 100;
			const subPerServing = onceDiscount < 100
				? oncePerServing * ((1 - subDiscount / 100) / (1 - onceDiscount / 100))
				: oncePerServing;
			const subEl = section.querySelector(".productSellingLabelBodyPerServing.sub");
			const onceEl = section.querySelector(".productSellingLabelBodyPerServing.once");
			if (subEl) subEl.textContent = `${price(subPerServing, true)}/serving`;
			if (onceEl) onceEl.textContent = `${price(oncePerServing, true)}/serving`;
		} else if (servingsPerBag > 0) {
			const subPerServing = basePrice * (1 - subDiscount / 100) / servingsPerBag;
			const oncePerServing = basePrice * (1 - onceDiscount / 100) / servingsPerBag;
			const subEl = section.querySelector(".productSellingLabelBodyPerServing.sub");
			const onceEl = section.querySelector(".productSellingLabelBodyPerServing.once");
			if (subEl) subEl.textContent = `${price(subPerServing, true)}/serving`;
			if (onceEl) onceEl.textContent = `${price(oncePerServing, true)}/serving`;
		}

		const frequencyEl = section.querySelector(".productSellingLabelBodyInfoFrequency.sub");
		const frequencyUnit = section.dataset.frequencyUnit;
		if (frequencyEl && frequencyUnit && servingsPerBag > 0) {
			frequencyEl.textContent = `${discountedQuantity} x ${servingsPerBag}-serve ${frequencyUnit}${discountedQuantity === 1 ? "" : "s"} every month`;
		}

		totalPrice = discountedPrice;
		if (basePrice * discountedQuantity > totalPrice) {
			totalCompare = price(basePrice * discountedQuantity, true);
		}
		if (isSubscription()) {
			totalPrice = subDiscountedPrice;
		}

		// calculate the remaining products to add to reach the minimum
		let remainingProductsToAdd = Math.max(0, minRequired - productsToAddCount);
		const productFlavorsHeaderRemaining = section.querySelector(".productFlavorsHeaderRemaining");
		if (remainingProductsToAdd === 0) {
			section.querySelectorAll(".ATC").forEach(function (btn) {
				// enable ATC
				btn.classList.remove("disabled");
				if (isV2Layout) {
					const compareMarkup = totalCompare ? `<s>${totalCompare}</s> ` : "";
					btn.innerHTML = `Add to Cart ${compareMarkup}<strong>${price(totalPrice, true)}</strong>`;
				} else {
					btn.innerHTML = `Add to Cart <span>${price(totalPrice, true)}</span> <s>${totalCompare}</s>`;
				}
			});
			if (productFlavorsHeaderRemaining) {
				productFlavorsHeaderRemaining.textContent = `Good to Go!`;
			}

		} else {
			section.querySelectorAll(".ATC").forEach(function (btn) {
				// disable ATC
				btn.classList.add("disabled");
				btn.textContent = `Select ${remainingProductsToAdd} more flavor${remainingProductsToAdd > 1 ? "s" : ""}`;
			});
			if (productFlavorsHeaderRemaining) {
				productFlavorsHeaderRemaining.textContent = `${remainingProductsToAdd} Flavor${remainingProductsToAdd > 1 ? "s" : ""} to Go`;
			}

			// if min required is 1, say select flavor
			if (minRequired === 1) {
				section.querySelectorAll(".ATC").forEach(function (btn) {
					btn.textContent = `Select Flavor`;
				});
			}
		}

		// Shipping notes
		if (isSubscription()) {
			section.querySelector(".productNotes").classList.add("active");
		} else {
			section.querySelector(".productNotes").classList.remove("active");
		}

		// sticky atc sub button
		if (isSubscription()) {
			section.querySelector(".productStickySub").classList.add("active");
		} else {
			section.querySelector(".productStickySub").classList.remove("active");
		}

		// sticky ATC text - no free shipping if one bag is selected or if it's one time purchase
		if (productCap === 1 || !isSubscription()) {
			section.querySelector(".productStickySubBodyTxt").textContent = `Skip or cancel anytime`;
		} else {
			section.querySelector(".productStickySubBodyTxt").textContent = `Free Shipping | Skip or cancel anytime`;
		}


		// update the product cap
		lastProductCap = productCap;
	}

	// on load, update the product
	updateProduct();


	// listen for scroll on productFlavorsBody, when it reaches the bottom hide scroll for more
	// (absent entirely on the single-SKU buy box, which has no flavor grid)
	section.querySelector(".productFlavorsBody")?.addEventListener("scroll", function () {
		let element = this;
		if (element.scrollHeight - element.scrollTop < element.clientHeight + 50) {
			section.querySelector(".productFlavorsBodyNote").classList.remove("active");
		} else {
			section.querySelector(".productFlavorsBodyNote").classList.add("active");
		}
	});

	/**************
		 Product Quantities
	 ***************/
	section.querySelectorAll(".productFlavorsBodyItem").forEach(function (element) {
		// plus
		element.querySelectorAll(".plus").forEach(function (btn) {
			btn.addEventListener("click", function () {
				let quantity = parseInt(element.dataset.quantity);

				const productCap = parseInt(getCheckedSizeInput()?.value || "1");
				const { maxAllowed } = getFlavorSelectionLimits(productCap);

				// if we're at the max flavors allowed, show an error
				if (Number.isFinite(maxAllowed) && productsToAddCount >= maxAllowed) {
					showLimitModal(maxAllowed);
					return;
				}

				// increment quantity
				quantity++;
				element.dataset.quantity = quantity;

				// update product
				element.querySelector(".productFlavorsBodyItemContentControlsCount").textContent = quantity;
				updateProduct();
			});
		});

		// minus
		element.querySelectorAll(".minus").forEach(function (btn) {
			btn.addEventListener("click", function () {
				let quantity = parseInt(element.dataset.quantity);

				if (quantity > 0) {
					quantity--;
					element.dataset.quantity = quantity;

					// update product
					element.querySelector(".productFlavorsBodyItemContentControlsCount").textContent = quantity;
					updateProduct();
				}
			});
		});
	});


	/**************
		 Product ATC
	 ***************/

	async function addToCart() {
		// add loading animation to both buttons
		section.querySelectorAll(".ATC").forEach(function (btn) {
			btn.classList.add("loading");
		});

		let formData = {
			items: [],
		};

		if (isMixNMatchMaltertechTemplate) {
			if (!mainProductVariant?.id) {
				console.warn("Main product variant not available, aborting add to cart.");
				section.querySelectorAll(".ATC").forEach(function (btn) {
					btn.classList.remove("loading");
				});
				return;
			}

			const kitId = parseInt(Math.random() * 100000);
			const kitTitle = bundleConfigEl?.dataset.kitTitle || "Latte Starter Kit";
			const isSub = isSubscription();
			const giftAttribution =
				bundleConfigEl?.dataset.subscriptionGiftAttribution ||
				"Rebuy Gift with Purchase";
			const includeGiftOnetime =
				bundleConfigEl?.dataset.subscriptionGiftIncludeOnetime === "true";

			const kitNotes = [];
			const conditions = [];
			const kitProperties = {
				_kitParent: kitId,
				"_Bundle #": kitId,
				_isSub: isSub,
			};
			const accessoryProperties = {
				_kitChild: kitId,
				"_Bundle #": kitId,
			};

			const mainItem = {
				quantity: 1,
				id: mainProductVariant.id,
				properties: kitProperties,
			};
			if (isSubscription() && mainProductSubscriptionPlanId) {
				mainItem.selling_plan = mainProductSubscriptionPlanId;
			}
			conditions.push(`${mainProductVariant.id}:1`);

			section.querySelectorAll(".productFlavorsBodyItem").forEach((flavorItem) => {
				const flavorQty = parseInt(flavorItem.dataset.quantity || "0");
				if (flavorQty <= 0) return;
				const flavorVariantId = flavorItem.dataset.id;
				const flavorTitle = flavorItem.dataset.title || "Flavor";
				const flavorPlanId = flavorItem.dataset.plan;
				kitProperties[flavorTitle] = flavorQty;
				kitNotes.push(`${flavorTitle}: ${flavorQty}`);
				conditions.push(`${flavorVariantId}:${flavorQty}`);

				const flavorProperties = {
					_kitChild: kitId,
					"_Bundle #": kitId,
					Kit: kitTitle,
				};
				const flavorLineItem = {
					id: flavorVariantId,
					quantity: flavorQty,
					properties: flavorProperties,
				};
				if (isSub && flavorPlanId) {
					flavorLineItem.selling_plan = flavorPlanId;
					flavorProperties._isSubscription = true;
				}
				formData.items.push(flavorLineItem);
			});

			bundleAddOnEls.forEach((addOnItem) => {
				const variantId = parseInt(addOnItem.dataset.variantId || "0");
				const quantity = parseInt(addOnItem.dataset.quantity || "1") || 1;
				if (!variantId) return;
				const title = addOnItem.dataset.title || "Add-on";
				const kind = addOnItem.dataset.kind || "include";
				if (kind === "accessory") {
					accessoryProperties[title] = quantity;
					kitNotes.push(`${title} x ${quantity}`);
					formData.items.push({
						id: variantId,
						quantity: quantity,
						properties: accessoryProperties,
					});
					return;
				}

				if (title.includes("SuperLatte")) {
					kitProperties[title] = quantity;
				} else {
					accessoryProperties[title] = quantity;
				}
				kitProperties[`_${variantId}`] = quantity;
				kitNotes.push(`${title} x ${quantity}`);
				conditions.push(`${variantId}:${quantity * quantity}`);
				formData.items.push({
					id: variantId,
					quantity: quantity,
					properties: {
						_kitChild: kitId,
						"_Bundle #": kitId,
						Kit: kitTitle,
					},
				});
			});

			if (isSub || includeGiftOnetime) {
				bundleGiftEls.forEach((giftItem) => {
					const variantId = parseInt(giftItem.dataset.variantId || "0");
					const quantity = parseInt(giftItem.dataset.quantity || "1") || 1;
					if (!variantId) return;
					formData.items.push({
						id: variantId,
						quantity: quantity,
						properties: {
							_kitChild: kitId,
							"_Bundle #": kitId,
							_attribution: giftAttribution,
						},
					});
				});
			}

			kitProperties["_Kit Notes"] = `${kitTitle}: ${kitNotes.join(", ")}`;
			kitProperties["_Conditions"] = conditions.join("|||");
			formData.items.push(mainItem);
		} else {
			const selectedSizeInput = getCheckedSizeInput();
			let discountKitValue = selectedSizeInput?.dataset.discountKitOnce;
			if (isSubscription()) {
				discountKitValue = selectedSizeInput?.dataset.discountKitSub;
			}

			let orderTagging = "_bundle_builder";

			// v2 tagging
			if (section.dataset.template === "page.maltertech-lp-v2") {
				orderTagging = "_bundle_builder_v2";
			}

			productsToAdd.forEach(product => {
				formData.items.push({
					quantity: product.quantity,
					id: product.id,
					selling_plan: product.selling_plan,
					properties: {
						"_discount_kit": discountKitValue,
						[orderTagging]: "true",
					},
				});
			});
		}


		// add product
		await addProduct(formData);

		// remove loading animation
		section.querySelectorAll(".ATC").forEach(function (btn) {
			btn.classList.remove("loading");
		});
	}

	section.querySelectorAll(".ATC").forEach(function (btn) {
		btn.addEventListener("click", async function () {
			if (this.classList.contains("disabled")) {
				return;
			}

			await addToCart();
		});
	});

	/**************
		 Sticky ATC
	 ***************/
	// add subscription
	section.querySelector(".productStickySub").addEventListener("click", function () {
		section.querySelector(".productSellingLabelInput[value=\"sub\"]").checked = true;
		updateProduct();
	});

	// scroll to product section on disabled ATC click
	section.querySelector(".productStickySubATC").addEventListener("click", function () {
		if (this.classList.contains("disabled")) {
			const scrollTarget = section.querySelector(".productFlavors") || section.querySelector("#main-product");
			scrollTarget?.scrollIntoView({ behavior: "smooth" });
		}
	});

	// Show the sticky ATC only after the real ATC has been scrolled past.
	// If the real ATC is still visible or still below the viewport, keep the
	// sticky bar hidden so customers see one purchase action at a time.
	const stickyFrame = section.querySelector(".productSticky");
	const mainAtc = section.querySelector(".productATC");
	const footer = document.querySelector('footer');
	let isFooterVisible = false;
	let hasScrolledPastMainAtc = false;

	function updateStickyAtcVisibility() {
		const showSticky = hasScrolledPastMainAtc && !isFooterVisible;
		stickyFrame.classList.toggle("active", showSticky);
		// the transform-only hide would leave the buttons tabbable while off-screen
		stickyFrame.inert = !showSticky;
	}

	// boundingClientRect.bottom is the source of truth (exact, no rounding);
	// threshold: 0 just wakes the callback up whenever mainAtc's intersection
	// with the viewport changes at all, same pattern as the footer observer below.
	const stickyAtcObserver = new IntersectionObserver(function (entries) {
		hasScrolledPastMainAtc = entries[entries.length - 1].boundingClientRect.bottom <= 0;
		updateStickyAtcVisibility();
	}, { threshold: 0 });
	stickyAtcObserver.observe(mainAtc);

	let stickyFooterObserver;
	if (footer) {
		stickyFooterObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				isFooterVisible = entry.isIntersecting;
				updateStickyAtcVisibility();
			});
		}, { threshold: 0 });

		stickyFooterObserver.observe(footer);
	}

	// Theme editor re-runs this script on every section reload without
	// unloading the page, so tear down our observers to avoid piling up
	// duplicates across edits.
	document.addEventListener("shopify:section:unload", function onStickyAtcUnload(event) {
		if (event.detail.sectionId !== sectionID) return;
		stickyAtcObserver.disconnect();
		stickyFooterObserver?.disconnect();
		document.removeEventListener("shopify:section:unload", onStickyAtcUnload);
	});

	/**************
		 Limit Modal
	 ***************/
	function showLimitModal(maxCap) {
		const modal = document.getElementById('limitReachedModal');
		if (!modal) return;

		// Update the max cap text
		const maxCapSpan = modal.querySelector('.limitModal__maxCap');
		if (maxCapSpan) {
			maxCapSpan.textContent = maxCap;
		}

		// Show modal
		modal.showModal();

		// Auto-close after 3 seconds
		const autoCloseTimer = setTimeout(function () {
			closeModalWithAnimation(modal);
		}, 3000);

		// Clear timer if user closes manually
		modal.addEventListener('close', function onClose() {
			clearTimeout(autoCloseTimer);
			modal.removeEventListener('close', onClose);
		}, { once: true });

		// Handle ESC key and backdrop click (built-in dialog features)
		modal.addEventListener('click', function (e) {
			const rect = modal.getBoundingClientRect();
			const isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height &&
				rect.left <= e.clientX && e.clientX <= rect.left + rect.width);
			if (!isInDialog) {
				closeModalWithAnimation(modal);
			}
		});
	}

	function closeModalWithAnimation(modal) {
		modal.classList.add('closing');

		// Wait for animation to finish before actually closing
		setTimeout(function () {
			modal.classList.remove('closing');
			modal.close();
		}, 200);
	}

}());
